import { fetchEntityById } from "../../apis/apiService";

// GET projects/budget/getTimeLogSavedSummary/{project_id}
// The utilisation figures for the logged-in user on one project, as of right now (so call it
// after the log has been saved). Resolves to the response's `data`.
export const fetchTimeLogSavedSummary = async (projectId) => {
  const response = await fetchEntityById("projects/budget/getTimeLogSavedSummary", projectId);
  if (!response?.status || !response.data) {
    throw new Error(response?.message || "No time log summary for this project");
  }
  return response.data;
};
